import axios, { AxiosPromise } from 'axios'

import { ImpressaoAtendimentoInput } from './ImpressaoAtendimentoIndividual'
export class ImpressaoAtendimentoVacinacao {
  imprimirAtendimentoVacinacao(input: ImpressaoAtendimentoInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirAtendimentoVacinacao', input, { responseType: 'blob' })
  }
}
